import { PureComponent } from "react";

import { routes } from "utilities/routes";

import { RelatedItemType } from "commonComponents/entity/relatedItem/RelatedItem.types";
import { RelatedItemTag } from "commonComponents/entity/relatedItem/RelatedItemTag/RelatedItemTag";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
    type IEntityLinkResponse,
} from "commonComponents/utilities/Grid/GridContainer.types";

export class RelatedPurchaseOrderLinksCell extends PureComponent<
    IGridCellRenderProps<IEntityLinkResponse[]>
> {
    render() {
        const { cellValue, field } = this.props;

        if (!cellValue) {
            return null;
        }

        return (
            <div data-testid={field.full}>
                {cellValue.map((po) => (
                    <RelatedItemTag
                        key={po.id}
                        data-testid={`${field.full}_${po.id}`}
                        itemType={RelatedItemType.PurchaseOrder}
                        to={routes.purchaseOrder.getDetailsPath(po.id, po.jobId)}
                        subject={po.title}
                        useMultiTagMargins
                    />
                ))}
            </div>
        );
    }
}

export const columnRelatedPurchaseOrderLinks: IClientGridColumn<IEntityLinkResponse[]> = {
    columnType: GridColumnType.relatedPurchaseOrderLinks,
    Cell: RelatedPurchaseOrderLinksCell,
};
